import { render, staticRenderFns } from "./order-editor.vue?vue&type=template&id=0625e36a&scoped=true&"
import script from "./order-editor.vue?vue&type=script&lang=ts&"
export * from "./order-editor.vue?vue&type=script&lang=ts&"
import style0 from "./order-editor.vue?vue&type=style&index=0&id=0625e36a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625e36a",
  null
  
)

export default component.exports